const ProductSang = [
    {
        ID: 60,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-2.jpg",
        CategoryID: 1001,
        Details: "Premium Coffee Cream",
        CompanyName: "Abarkuh"
    },
    {
        ID: 64,
        Name: "Marble Stone",
        ImageURL: "image/new-cat-2-6.jpeg",
        CategoryID: 1004,
        Details: "",
        CompanyName: "_"
    },
    {
        ID: 131,
        Name: "Lashtar Stone",
        ImageURL: "image/Stone/4-20.jpeg",
        CategoryID: 1002,
        Details: "Leather Bush Hammer",
        CompanyName: "_"
    },
    {
        ID: 150,
        Name: "Slab Stone",
        ImageURL: "image/Stone/3-5.jpeg",
        CategoryID: 1004,
        Details: "Black Rose Marble",
        CompanyName: "_"
    },
    {
        ID: 138,
        Name: "Golden Marble",
        ImageURL: "image/Stone/4-35.jpeg",
        CategoryID: 1002,
        Details: "Black 40 Length",
        CompanyName: "Najafabad"
    },
    {
        ID: 61,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-1.jpeg",
        CategoryID: 1001,
        Details: "Hot Spring",
        CompanyName: "Mohalat"
    },
    {
        ID: 67,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-3.jpeg",
        CategoryID: 1001,
        Details: "Super",
        CompanyName: "Abiyaneh"
    },
    {
        ID: 68,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-4.jpeg",
        CategoryID: 1001,
        Details: "Premium",
        CompanyName: "Abiyaneh"
    },
    {
        ID: 69,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-5.jpeg",
        CategoryID: 1001,
        Details: "Premium Cream",
        CompanyName: "Takab"
    },
    {
        ID: 70,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-6.jpeg",
        CategoryID: 1001,
        Details: "Chocolate",
        CompanyName: "Haji Abad"
    },
    {
        ID: 71,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-9.jpeg",
        CategoryID: 1001,
        Details: "Wave-less Cream",
        CompanyName: "Haji Abad"
    },
    {
        ID: 72,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-10.jpeg",
        CategoryID: 1001,
        Details: "Cotton Flower",
        CompanyName: "Haji Abad"
    },
    {
        ID: 73,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-7.jpeg",
        CategoryID: 1001,
        Details: "Premium",
        CompanyName: "Haji Abad"
    },
    {
        ID: 74,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-8.jpeg",
        CategoryID: 1001,
        Details: "Wavy",
        CompanyName: "Haji Abad"
    },
    {
        ID: 75,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-11.jpeg",
        CategoryID: 1001,
        Details: "Super",
        CompanyName: "Darabakhari"
    },
    {
        ID: 76,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-12.jpeg",
        CategoryID: 1001,
        Details: "Premium Cream",
        CompanyName: "Darabakhari"
    },
    {
        ID: 77,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-13.jpeg",
        CategoryID: 1001,
        Details: "Wavy Cream",
        CompanyName: "Darabakhari"
    },
    {
        ID: 78,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-14.jpeg",
        CategoryID: 1001,
        Details: "Gray",
        CompanyName: "Takab"
    },
    {
        ID: 79,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-37.jpg",
        CategoryID: 1001,
        Details: "First Grade",
        CompanyName: "Ramesh"
    },
    {
        ID: 80,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-39.jpg",
        CategoryID: 1001,
        Details: "Cream",
        CompanyName: "Ramesh"
    },
    {
        ID: 81,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-15.jpeg",
        CategoryID: 1001,
        Details: "White",
        CompanyName: "Mohalat"
    },
    {
        ID: 82,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-16.jpeg",
        CategoryID: 1001,
        Details: "Silver",
        CompanyName: "Takab"
    },
    {
        ID: 83,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-2.jpg",
        CategoryID: 1001,
        Details: "Chocolate",
        CompanyName: "Dehshir"
    },
    {
        ID: 84,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-17.jpeg",
        CategoryID: 1001,
        Details: "Chocolate",
        CompanyName: "Kashan"
    },
    {
        ID: 85,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-18.jpeg",
        CategoryID: 1001,
        Details: "Wave-less",
        CompanyName: "Abbas Abad"
    },
    {
        ID: 86,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-19.jpeg",
        CategoryID: 1001,
        Details: "Second Grade",
        CompanyName: "Abbas Abad"
    },
    {
        ID: 87,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-20.jpeg",
        CategoryID: 1001,
        Details: "Super",
        CompanyName: "Abbas Abad"
    },
    {
        ID: 88,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-21.jpeg",
        CategoryID: 1001,
        Details: "Widh 30 and 35",
        CompanyName: "Abbas Abad"
    },
    {
        ID: 89,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-24.jpeg",
        CategoryID: 1001,
        Details: "Cream",
        CompanyName: "Abbas Abad"
    },
    {
        ID: 90,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-22.jpeg",
        CategoryID: 1001,
        Details: "Premium",
        CompanyName: "Abbas Abad"
    },
    {
        ID: 91,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-23.jpeg",
        CategoryID: 1001,
        Details: "Curly Wave",
        CompanyName: "Abbas Abad"
    },
    {
        ID: 92,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-25.jpeg",
        CategoryID: 1001,
        Details: "Honey",
        CompanyName: "Kashan"
    },
    {
        ID: 93,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-30.jpeg",
        CategoryID: 1001,
        Details: "First Grade Cream",
        CompanyName: "Abarkuh"
    },
    {
        ID: 94,
        Name: "Travertine Stone",
        ImageURL: "image/new-cat-2-1.jpg",
        CategoryID: 1001,
        Details: "Second Grade Cream",
        CompanyName: "Abarkuh"
    },
    {
        ID: 95,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-5.jpeg",
        CategoryID: 1001,
        Details: "Cream",
        CompanyName: "Tarak"
    },
    {
        ID: 96,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-32.jpeg",
        CategoryID: 1001,
        Details: "Cream",
        CompanyName: "Kashan"
    },
    {
        ID: 97,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-30.jpeg",
        CategoryID: 1001,
        Details: "Cream",
        CompanyName: "Mohalat"
    },
    {
        ID: 98,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-31.jpeg",
        CategoryID: 1001,
        Details: "Premium Cream",
        CompanyName: "Ramesh"
    },
    {
        ID: 99,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-33.jpeg",
        CategoryID: 1001,
        Details: "Cream",
        CompanyName: "Yazd"
    },
    {
        ID: 100,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-34.jpeg",
        CategoryID: 1001,
        Details: "Super",
        CompanyName: "Kamashche"
    },
    {
        ID: 101,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-35.jpeg",
        CategoryID: 1001,
        Details: "Excellent",
        CompanyName: "Kamashcheh"
    },
    {
        ID: 102,
        Name: "Travertine Stone",
        ImageURL: "image/Stone/1-26.jpeg",
        CategoryID: 1001,
        Details: "",
        CompanyName: "Lushan"
    },
    {
        ID: 103,
        Name: "Slab Stone",
        ImageURL: "image/Stone/4-3.jpeg",
        CategoryID: 1002,
        Details: "Persian Silk",
        CompanyName: "_"
    },
    {
        ID: 104,
        Name: "Slab Stone",
        ImageURL: "image/Stone/4-1.jpeg",
        CategoryID: 1002,
        Details: "3D Black",
        CompanyName: "_"
    },
    {
        ID: 105,
        Name: "Slab Stone",
        ImageURL: "image/Stone/4-2.jpeg",
        CategoryID: 1002,
        Details: "DahbidSpidr Wavy",
        CompanyName: "_"
    },
    {
        ID: 106,
        Name: "Slab Stone",
        ImageURL: "image/Stone/4-6.jpeg",
        CategoryID: 1002,
        Details: "Emerald Crystal",
        CompanyName: "_"
    },
    {
        ID: 107,
        Name: "Slab Stone",
        ImageURL: "image/Stone/4-7.jpeg",
        CategoryID: 1002,
        Details: "LaibidCrystal",
        CompanyName: "_"
    },
    {
        ID: 108,
        Name: "Slab Stone",
        ImageURL: "image/Stone/4-8.jpeg",
        CategoryID: 1002,
        Details: "Golden Black",
        CompanyName: "Mahallat"
    },
    {
        ID: 109,
        Name: "Slab Stone",
        ImageURL: "image/Stone/4-4.jpeg",
        CategoryID: 1002,
        Details: "",
        CompanyName: "Lashtar"
    },
    {
        ID: 110,
        Name: "Slab Stone",
        ImageURL: "image/Stone/4-5.jpeg",
        CategoryID: 1002,
        Details: "",
        CompanyName: "Maku"
    },
    {
        ID: 111,
        Name: "Sandblasted Stone",
        ImageURL: "image/Stone/4-9.jpeg",
        CategoryID: 1002,
        Details: "Adavi",
        CompanyName: "_"
    },
    {
        ID: 112,
        Name: "Sandblasted Stone",
        ImageURL: "image/Stone/4-10.jpeg",
        CategoryID: 1002,
        Details: "Joushqan",
        CompanyName: "_"
    },
    {
        ID: 113,
        Name: "Sandblasted Stone",
        ImageURL: "image/Stone/4-11.jpeg",
        CategoryID: 1002,
        Details: "",
        CompanyName: "Lashtar"
    },
    {
        ID: 114,
        Name: "Plaque Stone",
        ImageURL: "image/Stone/4-4.jpeg",
        CategoryID: 1002,
        Details: "Marble",
        CompanyName: "Salsali"
    },
    {
        ID: 115,
        Name: "Step Stone",
        ImageURL: "image/Stone/4-16.jpeg",
        CategoryID: 1002,
        Details: "Peacock",
        CompanyName: "Yazd"
    },
    {
        ID: 116,
        Name: "Step Stone",
        ImageURL: "image/Stone/4-15.jpeg",
        CategoryID: 1002,
        Details: "Chiseled",
        CompanyName: "Lashtar"
    },
    {
        ID: 117,
        Name: "Step Stone",
        ImageURL: "image/Stone/4-17.jpeg",
        CategoryID: 1002,
        Details: "Marble",
        CompanyName: "Abadeh"
    },
    {
        ID: 118,
        Name: "Step Stone",
        ImageURL: "image/Stone/4-18.jpeg",
        CategoryID: 1002,
        Details: "Flat Marble",
        CompanyName: "_"
    },
    {
        ID: 119,
        Name: "Step Stone",
        ImageURL: "image/Stone/4-19.jpeg",
        CategoryID: 1002,
        Details: "Salsali Marble",
        CompanyName: "_"
    },
    {
        ID: 120,
        Name: "Chiseled Stone",
        ImageURL: "image/Stone/4-12.jpeg",
        CategoryID: 1002,
        Details: "Peacock",
        CompanyName: "_"
    },
    {
        ID: 121,
        Name: "Chiseled Stone",
        ImageURL: "image/Stone/4-13.jpeg",
        CategoryID: 1002,
        Details: "",
        CompanyName: "Lashtar"
    },
    {
        ID: 122,
        Name: "Cover Stone",
        ImageURL: "image/Stone/4-26.jpeg",
        CategoryID: 1002,
        Details: "Patterned",
        CompanyName: "Harsin"
    },
    {
        ID: 123,
        Name: "Cover Stone",
        ImageURL: "image/Stone/4-27.jpeg",
        CategoryID: 1002,
        Details: "Chiseled",
        CompanyName: "Lashtar"
    },
    {
        ID: 124,
        Name: "Cover Stone",
        ImageURL: "image/Stone/4-28.jpeg",
        CategoryID: 1002,
        Details: "Marble",
        CompanyName: "Abadeh"
    },
    {
        ID: 125,
        Name: "Cover Stone",
        ImageURL: "image/Stone/4-32.jpeg",
        CategoryID: 1002,
        Details: "Peacock Marble",
        CompanyName: "Yazd"
    },
    {
        ID: 126,
        Name: "Cover Stone",
        ImageURL: "image/Stone/4-29.jpeg",
        CategoryID: 1002,
        Details: "Flat Marble",
        CompanyName: "_"
    },
    {
        ID: 127,
        Name: "Cover Stone",
        ImageURL: "image/Stone/4-30.jpeg",
        CategoryID: 1002,
        Details: "Khoy Marble",
        CompanyName: "_"
    },
    {
        ID: 128,
        Name: "Cover Stone",
        ImageURL: "image/Stone/4-31.jpeg",
        CategoryID: 1002,
        Details: "Marble",
        CompanyName: "Salsali"
    },
    {
        ID: 129,
        Name: "Cover Stone",
        ImageURL: "image/Stone/4-33.jpeg",
        CategoryID: 1002,
        Details: "Marble",
        CompanyName: "Lashtar"
    },
    {
        ID: 130,
        Name: "Cover Stone",
        ImageURL: "image/Stone/4-34.jpeg",
        CategoryID: 1002,
        Details: "Marble",
        CompanyName: "Najaf Abad"
    },
    {
        ID: 132,
        Name: "Marble",
        ImageURL: "image/Stone/4-21.jpeg",
        CategoryID: 1002,
        Details: "40 Length",
        CompanyName: "Abadeh"
    },
    {
        ID: 133,
        Name: "Marble",
        ImageURL: "image/Stone/4-24.jpeg",
        CategoryID: 1002,
        Details: "Persian Oscar",
        CompanyName: "_"
    },
    {
        ID: 134,
        Name: "Marble",
        ImageURL: "image/Stone/4-25.jpeg",
        CategoryID: 1002,
        Details: "Peacock",
        CompanyName: "Yazd"
    },
    {
        ID: 135,
        Name: "Marble",
        ImageURL: "image/Stone/4-23.jpeg",
        CategoryID: 1002,
        Details: "Joushqan",
        CompanyName: "_"
    },
    {
        ID: 136,
        Name: "Chiseled Flooring",
        ImageURL: "image/Stone/4-36.jpeg",
        CategoryID: 1002,
        Details: "Marble",
        CompanyName: "Najaf Abad"
    },
    {
        ID: 137,
        Name: "Stone Flooring",
        ImageURL: "image/Stone/4-37.jpeg",
        CategoryID: 1002,
        Details: "Chinese Marble 60x60",
        CompanyName: "Najaf Abad"
    },
    {
        ID: 139,
        Name: "Marble",
        ImageURL: "image/Stone/4-29.jpeg",
        CategoryID: 1002,
        Details: "Flat Length",
        CompanyName: "_"
    },
    {
        ID: 140,
        Name: "Sandblasted Stone",
        ImageURL: "image/Stone/4-38.jpeg",
        CategoryID: 1002,
        Details: "",
        CompanyName: "Salsali"
    },
    {
        ID: 141,
        Name: "Slab Stone",
        ImageURL: "image/Stone/2-1.jpeg",
        CategoryID: 1003,
        Details: "Black Zebra Granite",
        CompanyName: "_"
    },
    {
        ID: 142,
        Name: "Slab Stone",
        ImageURL: "image/Stone/2-2.jpeg",
        CategoryID: 1003,
        Details: "Leather Green Court Granite",
        CompanyName: "_"
    },
    {
        ID: 143,
        Name: "Granite",
        ImageURL: "image/Stone/2-3.jpeg",
        CategoryID: 1003,
        Details: "Habibollahy",
        CompanyName: "_"
    },
    {
        ID: 144,
        Name: "Granite",
        ImageURL: "image/Stone/2-4.jpeg",
        CategoryID: 1003,
        Details: "Natanz Mohammadi",
        CompanyName: "_"
    },
    {
        ID: 145,
        Name: "Granite",
        ImageURL: "image/Stone/2-5.jpg",
        CategoryID: 1003,
        Details: "Nahbandan",
        CompanyName: "_"
    },
    {
        ID: 146,
        Name: "Marble",
        ImageURL: "image/Stone/3-1.jpeg",
        CategoryID: 1004,
        Details: "Golden Clodi Messy",
        CompanyName: "_"
    },
    {
        ID: 147,
        Name: "Antique Stone",
        ImageURL: "image/Stone/3-2.jpeg",
        CategoryID: 1004,
        Details: "Onyx Marble",
        CompanyName: "_"
    },
    {
        ID: 148,
        Name: "Antique Stone",
        ImageURL: "image/Stone/3-3.jpeg",
        CategoryID: 1004,
        Details: "Black and White",
        CompanyName: ""
    },
    {
        ID: 149,
        Name: "Antique Stone",
        ImageURL: "image/Stone/3-4.jpeg",
        CategoryID: 1004,
        Details: "Small and Large Square Marble",
        CompanyName: "_"
    },
    {
        ID: 151,
        Name: "Slab Stone",
        ImageURL: "image/Stone/3-9.jpeg",
        CategoryID: 1004,
        Details: "Princess Marble",
        CompanyName: "_"
    },
    {
        ID: 152,
        Name: "Slab Stone",
        ImageURL: "image/Stone/3-6.jpeg",
        CategoryID: 1004,
        Details: "Wavy Romantic Marble",
        CompanyName: "_"
    },
    {
        ID: 153,
        Name: "Slab Stone",
        ImageURL: "image/Stone/3-7.jpeg",
        CategoryID: 1004,
        Details: "Green Marble",
        CompanyName: "_"
    },
    {
        ID: 154,
        Name: "Slab Stone",
        ImageURL: "image/Stone/3-8.jpeg",
        CategoryID: 1004,
        Details: "Pink Marble",
        CompanyName: "_"
    },
    {
        ID: 155,
        Name: "Slab Stone",
        ImageURL: "image/Stone/3-10.jpeg",
        CategoryID: 1004,
        Details: "Golden Clodi Marble",
        CompanyName: "_"
    },
    {
        ID: 156,
        Name: "Slab Stone",
        ImageURL: "image/Stone/3-11.jpeg",
        CategoryID: 1004,
        Details: "Multi-Color Honey Marble",
        CompanyName: "_"
    },
    {
        ID: 62,
        Name: "Marble Stone",
        ImageURL: "image/new-cat-2-2.jpeg",
        CategoryID: 1002,
        Details: "",
        CompanyName: "Tehran"
    },
    {
        ID: 63,
        Name: "Granite Stone",
        ImageURL: "image/new-cat-2-3.jpeg",
        CategoryID: 1003,
        Details: "",
        CompanyName: "_"
    },
    {
        ID: 65,
        Name: "Abbasabad Stone",
        ImageURL: "image/new-cat-2-4.jpeg",
        CategoryID: 1005,
        Details: "",
        CompanyName: "_"
    },
    {
        ID: 66,
        Name: "Lashtar Stone",
        ImageURL: "image/new-cat-2-5.jpeg",
        CategoryID: 1006,
        Details: "",
        CompanyName: "_"
    }

]

export default ProductSang;